import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const LANGUAGE_DIRECTIONS: Record<string, "ltr" | "rtl"> = {
  en: "ltr",
  es: "ltr",
  fr: "ltr",
  de: "ltr",
  ja: "ltr",
  "pt-BR": "ltr",
  "zh-CN": "ltr",
  "zh-TW": "ltr",
  ru: "ltr",
  hi: "ltr",
  "fil-PH": "ltr",
  gr: "ltr",
  sp: "ltr",
  pt: "ltr",
  fil: "ltr",
  he_IL: "rtl",
  he: "rtl",
  ar: "rtl",
};

export const getTextDirection = (languageCode: string): "ltr" | "rtl" => {
  return LANGUAGE_DIRECTIONS[languageCode] || "ltr";
};

export const isRTL = (languageCode: string) => {
  return getTextDirection(languageCode) === "rtl";
};

export const useDirection = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const direction: "ltr" | "rtl" = getTextDirection(i18n.language);
    const lang = i18n.language;

    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", lang);

    document.body.className = document.body.className.replace(/rtl|ltr/g, "").trim();
    document.body.classList.add(direction);

    return () => {
      document.body.classList.remove("rtl", "ltr");
    };
  }, [i18n.language]);

  return {
    direction: getTextDirection(i18n.language),
    isRTL: isRTL(i18n.language),
  };
};
